<template>
  <v-app>
    <v-app-bar app color="primary">
      <v-toolbar-title><router-link to="/">Grochowski's Guestbook</router-link></v-toolbar-title>
      <!--<v-spacer></v-spacer>
      
      <router-link to="/"><v-btn text>Strona Główna</v-btn></router-link> |
      <router-link to="/add"><v-btn text>Dodaj Wpis</v-btn></router-link>-->
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <!--<v-footer color="primary" padless>
      <v-col
        class="text-center"
        cols="12"
      >
      Grochowski's Guestbook &mdash; 2025.04 &mdash; Designed by Marcel Maruszak ❤️
      </v-col>
    </v-footer>-->
  </v-app>
</template>

<script>
import { RouterLink, RouterView } from 'vue-router';
import { VApp, VAppBar, VToolbarTitle, VMain } from 'vuetify/components';

export default {
  components: {
    RouterLink,
    RouterView,
    VApp,
    VAppBar,
    VToolbarTitle,
    VMain,
  },
};
</script>

<style scoped>
a {
  color: inherit;
  text-decoration: none;
}

.v-footer {
  color: white; /* Tekst w stopce */
}

.v-toolbar-title {
  color: white; /* Tekst w nagłówku */
}
</style>